<template>
  <card>
    <h2 class="mt-2"> Welcome to Incentify! </h2>
      <br><br>
      <div>
        To get started: <button class="btn btn-primary" @click="goToSetup()">Go to Setup</button>
        <br><br><br>
      </div>
      <div>
        <h5>To activate your account you need to complete and save your profile</h5>
      </div>
      <br>
  </card>
</template>

<script>
export default {
    name: 'Welcome-Card',
    methods: {
      icon (status) {
        return status ? 'fas fa-check text-success' : 'fas fa-check text-light-gray'
      },
      accountDataAvailable () { return !!this.$store.getters.accountSetup},
      goToSetup () {
        this.$router.push({path: '/dashboard/setup'})
      }
    },
    computed: {
    },
}
</script>

<style>

</style>